import { useEffect, useState } from "react";
import api from "@/lib/api";

// Live presence: sends a heartbeat while active and returns the current viewers.
export function usePresence(entityType, entityId, active = true) {
  const [viewers, setViewers] = useState([]);
  useEffect(() => {
    if (!active || !entityId) { setViewers([]); return; }
    let alive = true;
    const beat = async () => {
      try {
        const { data } = await api.post("/presence", { entity_type: entityType, entity_id: entityId });
        if (alive) setViewers(data || []);
      } catch (e) { /* silent */ }
    };
    beat();
    const id = setInterval(beat, 20000);
    return () => {
      alive = false;
      clearInterval(id);
      api.delete("/presence", { params: { entity_type: entityType, entity_id: entityId } }).catch(() => {});
    };
  }, [entityType, entityId, active]);
  return viewers;
}

// Bulk presence for a list view: map of entityId -> [{user_id, name}]
export function usePresenceBulk(entityType, deps = []) {
  const [map, setMap] = useState({});
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/presence/bulk", { params: { entity_type: entityType } });
        if (alive) setMap(data || {});
      } catch (e) { /* silent */ }
    };
    load();
    const id = setInterval(load, 20000);
    return () => { alive = false; clearInterval(id); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityType, ...deps]);
  return map;
}
